import { render, staticRenderFns } from "./TemporaryAssistanceForm.vue?vue&type=template&id=6682afe4&scoped=true"
import script from "./TemporaryAssistanceForm.vue?vue&type=script&lang=js"
export * from "./TemporaryAssistanceForm.vue?vue&type=script&lang=js"
import style0 from "./TemporaryAssistanceForm.vue?vue&type=style&index=0&id=6682afe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6682afe4",
  null
  
)

export default component.exports